import {useAccountNavigation} from "../../hooks/useAccountNavigation";

interface AccountAreaProps {
    className?: string;
    accountNo?: string;
    bankName?: string;
}

export const AccountArea =  ({ className, accountNo, bankName }: AccountAreaProps) => {

    return (
        <>
            <div className={className}>
                <span className="label">등록계좌</span>
                <a className="arrow-btn" onClick={useAccountNavigation(accountNo)}>
                    {accountNo != null ? (
                        <span
                            className="cont">{bankName + " " + accountNo}</span>
                    ) : (
                        <span className="cont">환불을 위한 계좌를 등록해주세요.</span>
                    )}
                    <i className="fa-solid fa-angle-right"></i>
                </a>
            </div>
        </>
    )
};